// sekcie_v1 (20. 10. 2026, 0.J): DetailRow je jeden, v components/Ui.jsx
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 2 miest
// ╔══════════════════════════════════════════════════════════════════╗
// ║  KontaktyView.jsx — KONTAKTY (kontaktné osoby partnerov)          ║
// ║  Vznikol kópiou _ModuleTemplate.jsx (ústava 9.D.1).               ║
// ╚══════════════════════════════════════════════════════════════════╝
// p93 — Mirko 21. 9. 2026: „Matrix má síce partnerov, ale nemá kontakty, to je tiež dôležité."
// NIE JE to druhý register (ústava 0.J): obrazovka nad JEDINÝM registrom partner_contacts (131.10), z ktorého
// berú osobu dopyt, obhliadka, kalkulácia, cenová ponuka, objednávka, poterový protokol, zákazka aj SMS.
// Pri osobe vidno jej doklady — väzba cez e-mail, inak telefón.

import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import { Link } from 'react-router-dom'
import { COLORS, TYPO, SPACE, RADIUS, TINT, todayLocal, norm } from '../theme.js'
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect, DetailRow } from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import RowMenu from '../components/RowMenu.jsx'
import ExportMenu from '../components/ExportMenu.jsx'
import useSortable from '../hooks/useSortable.js'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import TelefonInput from '../components/TelefonInput.jsx'
import SmsButton from '../components/SmsButton.jsx'
import { FUNKCIE, OsobaBunky, bunkyOsoby } from '../components/KontaktyPartnera.jsx'

// ╔═══ KONFIGURÁCIA MODULU ══════════════════════════════════════════╗
// resource = segment API = zámok = modul auditu (partner_contacts_api zapisuje 'partner-contacts')
const CFG = {
  resource:    'partner-contacts',
  apiBase:     '/api/partner-contacts',
  title:       'Kontakt',
  titlePlural: 'Kontakty',
  newLabel:    'Nový kontakt',
  exportColumns: [
    { key: 'meno', label: 'Meno' }, { key: 'funkcia', label: 'Funkcia' }, { key: 'customer_name', label: 'Partner' },
    { key: 'telefon', label: 'Telefón' }, { key: 'email', label: 'E-mail' }, { key: 'pocet_dokladov', label: 'Doklady' },
  ],
  sortColumns: [
    { key: 'meno', label: 'Meno' }, { key: 'customer_name', label: 'Partner' },
    { key: 'pocet_dokladov', label: 'Doklady' }, { key: 'created_at', label: 'Pridané' },
  ],
}

// Polia pre DIFF (ústava 53.8)
const EDIT_FIELDS = [
  { name: 'titul',       label: 'Titul' },
  { name: 'first_name',  label: 'Meno' },
  { name: 'last_name',   label: 'Priezvisko' },
  { name: 'funkcia',     label: 'Funkcia' },
  { name: 'customer_id', label: 'Partner' },
  { name: 'telefon',     label: 'Telefón' },
  { name: 'email',       label: 'E-mail' },
  { name: 'poznamka',    label: 'Poznámka' },
]

// Skupiny podľa funkcie — funkcia je voľný text, skupina sa len odvodí (nič sa neukladá)
const SKUPINY = [
  { key: 'all',      label: 'Všetky',                 color: COLORS.muted },
  { key: 'rozpocet', label: 'Rozpočtári',             color: COLORS.nav },
  { key: 'stavba',   label: 'Stavbyvedúci a majstri', color: COLORS.brand },
  { key: 'priprava', label: 'Technici a príprava',    color: COLORS.add },
  { key: 'vedenie',  label: 'Vedenie',                color: COLORS.text },
  { key: 'ostatni',  label: 'Ostatní',                color: COLORS.muted },
]
const skupina = (f) => {
  const x = norm(f || '')
  if (/rozpoc/.test(x)) return 'rozpocet'
  if (/stavbyved|majster/.test(x)) return 'stavba'
  if (/techn|priprav|projekt/.test(x)) return 'priprava'
  if (/konatel|riaditel|majitel|prokurist/.test(x)) return 'vedenie'
  return 'ostatni'
}
const farba = (f) => (SKUPINY.find(s => s.key === skupina(f)) || SKUPINY[5]).color
const dmy = (s) => { const m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? Number(m[3]) + '. ' + Number(m[2]) + '. ' + m[1] : '' }
const EMAIL_OK = /^[^@\s,;]+@[^@\s,;]+\.[^@\s,;]+$/

// ══════════════════════════════════════════════════════════════════
// HLAVNÝ KOMPONENT — master-detail stránka (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
export default function KontaktyView() {
  const { user } = useAuth()
  const toast = useToast()
  const confirm = useConfirm()
  const pos = usePositionMemory(CFG.resource)
  const listRef = useRef(null)

  const [rows, setRows]       = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch]   = useState(pos.filter?.search || '')
  const [filter, setFilter]   = useState(pos.filter?.status || 'all')
  const [selectedId, setSelectedId] = useState(pos.selectedRow || null)
  const [modal, setModal]     = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const r = await fetchAuth(CFG.apiBase + '?vsetky=1')
      const d = await r.json()
      setRows(Array.isArray(d) ? d : [])
    } catch (_) {
      toast.error('Kontakty sa nenačítali.')
    } finally {
      setLoading(false)
    }
  }, [toast])
  useEffect(() => { load() }, [load])

  // ── filter + hľadanie bez diakritiky (66.1); telefón aj bez medzier a predvoľby ──
  const filtered = useMemo(() => {
    const q = norm(search.trim())
    const cq = search.replace(/\D/g, '')
    return rows.filter(row => {
      if (filter !== 'all' && skupina(row.funkcia) !== filter) return false
      if (!q) return true
      if ([row.meno, row.funkcia, row.customer_name, row.email, row.poznamka].some(v => v != null && norm(v).includes(q))) return true
      return cq.length >= 3 && String(row.telefon || '').replace(/\D/g, '').includes(cq)
    })
  }, [rows, search, filter])

  const sortable = useSortable(filtered)
  const selected = useMemo(() => rows.find(r => r.id === selectedId) || null, [rows, selectedId])

  // p103 (Mirko 22. 9. 2026: „prejsť rýchlo z kontaktu do zamestnanca alebo partnera"): ?open=<id> otvorí kartu
  const [openZKontaktov, setOpenZKontaktov] = useState(() => { try { return new URLSearchParams(window.location.search).get('open') } catch (_) { return null } })
  useEffect(() => {
    if (!openZKontaktov || !rows || !rows.length) return
    const r = rows.find(x => String(x.id) === String(openZKontaktov)); setOpenZKontaktov(null)
    if (r) { setSelectedId(r.id) }
  }, [rows])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── pamäť pozície (ústava 53.3) ──
  useEffect(() => { pos.selectRow(selectedId) }, [selectedId, pos.selectRow])
  useEffect(() => { pos.setFilter({ status: filter, search }) }, [filter, search, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── klávesnica (ústava 54.2, 56.5) ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  useListKeyboard({ items: sortable.sorted, selectedId, onSelect: setSelectedId, onOpen: openRecord, enabled: !modal })
  useShortcuts([
    { keys: 'alt+n', label: CFG.newLabel, scope: CFG.resource, handler: () => setModal({ record: null }) },
    { keys: '/', label: 'Hľadať', scope: CFG.resource, handler: () => {
      const el = document.querySelector(`[data-${CFG.resource}-search]`)
      if (el) el.focus()
    } },
  ])

  // ── KPI (ústava 56.8) ──
  const kpi = useMemo(() => ({
    total: rows.length,
    partneri: new Set(rows.map(r => r.customer_id).filter(Boolean)).size,
    sDokladmi: rows.filter(r => Number(r.pocet_dokladov) > 0).length,
  }), [rows])

  const odstran = async (row) => {
    const ok = await confirm({
      title: 'Odstrániť kontakt?',
      message: `Kontakt ${row.meno || row.email || row.id} sa presunie do archívu. Z dokladov nezmizne a dá sa vrátiť.`,
      danger: true, confirmLabel: 'Odstrániť',
    })
    if (!ok) return
    try {
      const r = await fetchAuth(`${CFG.apiBase}/${row.id}`, { method: 'DELETE' })
      if (!r.ok) throw new Error('odstránenie zlyhalo')
      toast.success('Kontakt je v archíve.')
      if (selectedId === row.id) setSelectedId(null)
      load()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title={CFG.titlePlural} subtitle={`${filtered.length} z ${rows.length} · kontaktné osoby partnerov`}>
        <ExportMenu data={sortable.sorted} filename={`kontakty-${todayLocal()}`} title={CFG.titlePlural} columns={CFG.exportColumns} />
        <BtnAdd onClick={() => setModal({ record: null })}
          title="Založí kontaktnú osobu k partnerovi. Hneď ju ponúkne dopyt, obhliadka, kalkulácia, ponuka, objednávka aj SMS.">+ {CFG.newLabel}</BtnAdd>
      </PageHeader>

      <KpiRow cols={3}>
        <KpiCard title="Kontakty" color={COLORS.nav} value={kpi.total} />
        <KpiCard title="Partneri s kontaktmi" color={COLORS.brand} value={kpi.partneri} />
        <KpiCard title="Na dokladoch" color={COLORS.add} value={kpi.sDokladmi} />
      </KpiRow>

      <div style={{ height: SPACE.md }} />

      <MasterDetail
        left={
          <>
            <SearchInput value={search} onChange={setSearch}
              dataAttr={`data-${CFG.resource}-search`}
              placeholder="Hľadať meno, firmu, e-mail, telefón (stlač /)…" />
            <FilterChips options={SKUPINY} value={filter} onChange={setFilter} />
            {/* MULTI-SORT chips — ústava sek. 66.1 bod 4 */}
            <div style={{ padding: '4px 10px', borderBottom: `1px solid ${COLORS.line}`,
              display: 'flex', alignItems: 'center', gap: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted, flexWrap: 'wrap' }}>
              <span>Zoradiť:</span>
              {CFG.sortColumns.map(c => {
                const ind = sortable.sortIndicator(c.key)
                return (
                  <button key={c.key} onClick={(e) => sortable.sortClick(c.key)(e)}
                    title="Klik = zoradiť, Shift+klik = pridať druhý kľúč"
                    style={{
                      padding: '2px 8px',
                      background: ind ? COLORS.navBg : 'transparent',
                      border: `1px solid ${ind ? COLORS.brand : COLORS.line}`,
                      borderRadius: RADIUS.full, cursor: 'pointer',
                      fontSize: TYPO.sizes.xs, color: ind ? COLORS.brand : COLORS.muted,
                      fontFamily: 'inherit',
                    }}>{c.label}{ind ? ' ' + ind : ''}</button>
                )
              })}
            </div>
            <div ref={listRef}
              onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
              style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div>
              ) : filtered.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  {rows.length ? 'Nič sa nenašlo.' : 'Zatiaľ žiadne kontakty — pridaj prvý (+ Nový kontakt).'}
                </div>
              ) : sortable.sorted.map(row => (
                <ListRow key={row.id}
                  dataId={row.id}
                  selected={row.id === selectedId}
                  stripColor={farba(row.funkcia)}
                  onClick={() => setSelectedId(row.id)}
                  onDoubleClick={() => setModal({ record: row })}
                >
                  {/* ústava 66.2: meno tučne + funkcia vpravo; pod tým partner · telefón (mono), e-mail */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {row.meno || row.email || '(bez mena)'}
                      </div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 2 }}>
                        {[row.customer_name || row.customer_id, row.telefon].filter(Boolean).join(' · ')}
                      </div>
                      {row.email && (
                        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 1, whiteSpace: 'normal', wordBreak: 'break-all' }}>{row.email}</div>
                      )}
                    </div>
                    <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                      {row.funkcia && <FunkciaTag funkcia={row.funkcia} />}
                      <RowMenu actions={[
                        { key: 'edit', label: 'Upraviť', onClick: () => setModal({ record: row }) },
                        ...(row.email ? [{ key: 'mail', label: 'Napísať e-mail', onClick: () => { window.location.href = 'mailto:' + row.email } }] : []),
                        { separator: true },
                        { key: 'del', label: 'Odstrániť', danger: true, onClick: () => odstran(row) },
                      ]} />
                    </div>
                  </div>
                </ListRow>
              ))}
            </div>
            <ListStatusBar>↑↓ výber · Enter upraviť · Alt+N nový · / hľadať</ListStatusBar>
          </>
        }
        right={
          selected
            ? <DetailPane record={selected} onEdit={() => setModal({ record: selected })} />
            : <EmptyPane text="Vyber kontakt vľavo, alebo pridaj nový (+ Nový kontakt)" />
        }
      />

      {modal && (
        <RecordModal
          open
          record={modal.record}
          user={user}
          onClose={() => setModal(null)}
          onSaved={(novyId) => {
            setModal(null)
            load()
            if (novyId) setSelectedId(novyId)
            toast.success('Uložené.')
          }}
        />
      )}
    </div>
  )
}

// Štítok funkcie — farba skupiny, bez výplne (ústava 21.15)
function FunkciaTag({ funkcia }) {
  const c = farba(funkcia)
  return (
    <span title={funkcia} style={{
      fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: c, border: `1px solid ${c}`,
      borderRadius: RADIUS.sm, padding: '1px 7px', maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
    }}>{funkcia}</span>
  )
}

// ══════════════════════════════════════════════════════════════════
// DETAIL — taby Detail / Doklady / História (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
function DetailPane({ record, onEdit }) {
  const [tab, setTab] = useState('detail')
  const [doklady, setDoklady] = useState(null)
  useEffect(() => {
    let zive = true
    setDoklady(null)
    fetchAuth(`${CFG.apiBase}/${record.id}/doklady`)
      .then(r => (r.ok ? r.json() : { doklady: [] }))
      .then(d => { if (zive) setDoklady(Array.isArray(d.doklady) ? d.doklady : []) })
      .catch(() => { if (zive) setDoklady([]) })
    return () => { zive = false }
  }, [record.id, record.email, record.telefon])

  const odkaz = { color: COLORS.nav, textDecoration: 'none' }
  return (
    <div style={{
      background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg,
      height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
      {/* HLAVIČKA KARTY — tenký pásik farbou skupiny + čierne meno (ústava 61.6) */}
      <div style={{ height: 4, background: farba(record.funkcia) }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, padding: `${SPACE.md}px ${SPACE.lg}px`, borderBottom: `1px solid ${COLORS.line}`, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, color: COLORS.text }}>
          {record.meno || record.email || '(bez mena)'}
        </h2>
        {record.funkcia && <FunkciaTag funkcia={record.funkcia} />}
        <div style={{ flex: 1 }} />
        {record.telefon && <SmsButton to={record.telefon} entityType="partner-contacts" entityId={record.id} label="SMS" />}
        <Btn variant="nav" onClick={onEdit}>Upraviť</Btn>
      </div>
      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
        <Tabs value={tab} onChange={setTab} tabs={[
          { key: 'detail', label: 'Detail' },
          { key: 'doklady', label: doklady ? `Doklady (${doklady.length})` : 'Doklady' },
          { key: 'history', label: 'História' },
        ]} />
        {tab === 'detail' && (
          <div style={{ fontSize: TYPO.sizes.base, lineHeight: 1.7 }}>
            <DetailRow label="Meno a priezvisko" value={record.meno} />
            <DetailRow label="Funkcia" value={record.funkcia} />
            <DetailRow label="Partner" value={record.customer_id
              ? <Link to={'/partneri/' + record.customer_id} style={odkaz}>{record.customer_name || record.customer_id}</Link> : null} />
            <DetailRow label="Telefón" value={record.telefon
              ? <a href={'tel:' + String(record.telefon).replace(/\s/g, '')} style={odkaz}>{record.telefon}</a> : null} />
            <DetailRow label="E-mail" value={record.email ? <a href={'mailto:' + record.email} style={odkaz}>{record.email}</a> : null} />
            <DetailRow label="Poznámka" value={record.poznamka} />
            <DetailRow label="Pridané" value={[dmy(record.created_at), record.created_by].filter(Boolean).join(' · ')} />
            <DetailRow label="Upravené" value={[dmy(record.updated_at), record.updated_by].filter(Boolean).join(' · ')} />
          </div>
        )}
        {tab === 'doklady' && (
          doklady === null ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div>
            : !doklady.length ? (
              <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                Táto osoba zatiaľ nie je na žiadnom doklade. Doklad sa k nej priradí podľa e-mailu, inak podľa telefónu.
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                  <thead>
                    <tr style={{ background: TINT.nav }}>
                      <th style={thStyle}>Doklad</th><th style={thStyle}>Číslo</th><th style={thStyle}>Názov / stavba</th>
                      <th style={thStyle}>Dátum</th><th style={thStyle}>Stav</th>
                    </tr>
                  </thead>
                  <tbody>
                    {doklady.map(d => (
                      <tr key={d.typ + ':' + d.id}>
                        <td style={tdStyle}>{d.trasa ? <Link to={d.trasa} style={odkaz}>{d.druh}</Link> : d.druh}</td>
                        <td style={{ ...tdStyle, fontFamily: TYPO.mono }}>{d.cislo || '—'}</td>
                        <td style={tdStyle}>{d.nazov || '—'}</td>
                        <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>{dmy(d.datum) || '—'}</td>
                        <td style={{ ...tdStyle, color: COLORS.muted }}>{d.stav || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
        )}
        {tab === 'history' && <HistoryPanel module={CFG.resource} entityId={record.id} />}
      </div>
    </div>
  )
}


// ══════════════════════════════════════════════════════════════════
// RECORD MODAL — nový / úprava cez useRecordEditor
// Zámok + dirty + Form → Confirm + DIFF — všetko v hooku (ústava 53.1, 53.7, 53.8).
// ══════════════════════════════════════════════════════════════════
function RecordModal({ open, record, user, onClose, onSaved }) {
  const isNew = !record
  const [partneri, setPartneri] = useState([])
  const [dlId] = useState(() => 'kontakty-funkcie-' + Math.random().toString(36).slice(2, 8))
  const novyId = useRef(null)
  useEffect(() => {
    if (!isNew) return
    fetchAuth('/api/customers').then(r => (r.ok ? r.json() : [])).then(d => setPartneri(Array.isArray(d) ? d : [])).catch(() => {})
  }, [isNew])

  const ed = useRecordEditor({
    resource: CFG.resource,
    id: record?.id || null,
    user,
    initial: {
      ...bunkyOsoby(record),   // KONTAKT_BUNKY_V1 (ústava 139) — titul · meno · priezvisko
      funkcia:     record?.funkcia     || '',
      customer_id: record?.customer_id || '',
      telefon:     record?.telefon     || '',
      email:       record?.email       || '',
      poznamka:    record?.poznamka    || '',
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const telo = {
        titul: values.titul.trim(), first_name: values.first_name.trim(), last_name: values.last_name.trim(), funkcia: values.funkcia.trim(), telefon: String(values.telefon || '').trim(),
        email: values.email.trim(), poznamka: values.poznamka,
      }
      const r = await fetchAuth(isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`, {
        method: isNew ? 'POST' : 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(isNew ? { ...telo, customer_id: values.customer_id } : telo),
      })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) {
        if (r.status === 409) throw new Error(d.message || d.error || 'Taký kontakt už existuje.')
        throw new Error(d.error || 'Uloženie zlyhalo.')
      }
      // dedup (ústava 13): rovnaký e-mail alebo telefón u toho istého partnera = tá istá osoba
      if (isNew && d.duplicate) throw new Error('Tento e-mail alebo telefón už partner má — kontakt „' + (d.meno || d.email || d.telefon) + '“ existuje. Uprav ten.')
      novyId.current = isNew ? d.id : null
    },
  })

  if (!open) return null

  const doClose = () => ed.requestClose(onClose)
  const validate = (v) => {
    if (!String(v.first_name || '').trim() || !String(v.last_name || '').trim()) return 'Meno aj priezvisko sú povinné.'
    if (isNew && !v.customer_id) return 'Vyber partnera — kontaktná osoba vždy patrí k partnerovi.'
    if (!String(v.email || '').trim() && !String(v.telefon || '').trim()) return 'Zadaj e-mail alebo telefón.'
    if (String(v.email || '').trim() && !EMAIL_OK.test(v.email.trim())) return 'E-mail nie je platný.'
    return null
  }
  const handleConfirm = async () => {
    const ok = await ed.submit()
    if (ok) onSaved(novyId.current)
  }
  const readOnly = !ed.canEdit
  const partnerMeno = isNew
    ? ((partneri.find(c => String(c.id) === String(ed.values.customer_id)) || {}).name || ed.values.customer_id)
    : (record.customer_name || record.customer_id)

  return (
    <>
      <Modal
        open
        onClose={doClose}
        onDirtyClose={doClose}
        isDirty={ed.isDirty}
        title={isNew ? CFG.newLabel : `Upraviť — ${record.meno || record.email}`}
        subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny pred uložením' : 'Osobu hneď ponúkne dopyt, obhliadka, kalkulácia, ponuka, objednávka aj SMS.'}
        maxWidth={640}
        footer={
          ed.phase === 'form' ? (
            <>
              <BtnGhost onClick={doClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={() => ed.goConfirm(validate)} disabled={readOnly}>Uložiť →</BtnAdd>
            </>
          ) : (
            <>
              <BtnGhost onClick={ed.back}>← Späť na úpravu</BtnGhost>
              <BtnAdd onClick={handleConfirm} disabled={ed.submitting}>
                {ed.submitting ? 'Ukladám…' : 'Potvrdiť uloženie'}
              </BtnAdd>
            </>
          )
        }
      >
        {/* ZÁMOK — kontakt upravuje niekto iný (ústava 53.7) */}
        {readOnly && ed.lockedBy && (
          <div style={{ background: TINT.remove, border: `1px solid ${COLORS.remove}`, borderRadius: RADIUS.md,
            padding: SPACE.sm, marginBottom: SPACE.md, fontSize: TYPO.sizes.sm, color: COLORS.remove }}>
            Kontakt práve upravuje <strong>{ed.lockedBy}</strong>. Úprava je zamknutá.
          </div>
        )}
        {ed.error && (
          <div style={{ background: TINT.remove, border: `1px solid ${COLORS.remove}`, borderRadius: RADIUS.md,
            padding: SPACE.sm, marginBottom: SPACE.md, fontSize: TYPO.sizes.sm, color: COLORS.remove }}>{ed.error}</div>
        )}

        {ed.phase === 'form' ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <div style={{ display: 'grid' }}>
              <OsobaBunky v={ed.values} set={ed.set} disabled={readOnly} autoFocus inp={inputStyle}
                lbl={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold, color: COLORS.text, minWidth: 0 }} />
            </div>
            <Field label="Funkcia">
              <input list={dlId} value={ed.values.funkcia} disabled={readOnly} placeholder="napr. rozpočtár"
                onChange={e => ed.set('funkcia', e.target.value)} style={inputStyle} />
              <datalist id={dlId}>{FUNKCIE.map(x => <option key={x} value={x} />)}</datalist>
            </Field>
            <Field label={isNew ? 'Partner *' : 'Partner'}>
              {isNew ? (
                <SearchableSelect value={ed.values.customer_id} onChange={v => ed.set('customer_id', v)} menuPortal
                  options={partneri.map(c => ({ value: String(c.id), label: c.name + ' (' + c.id + ')' }))}
                  placeholder="Hľadať partnera…" />
              ) : (
                <div style={{ ...inputStyle, background: COLORS.lineSoft }}>{partnerMeno || '—'}</div>
              )}
            </Field>
            <Field label="Telefón">
              <TelefonInput value={ed.values.telefon} disabled={readOnly} onChange={v => ed.set('telefon', v)} style={inputStyle} />
            </Field>
            <Field label="E-mail">
              <input type="email" value={ed.values.email} disabled={readOnly} placeholder="meno@firma.sk"
                onChange={e => ed.set('email', e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Poznámka">
              <textarea value={ed.values.poznamka} disabled={readOnly} rows={3}
                onChange={e => ed.set('poznamka', e.target.value)} style={{ ...inputStyle, resize: 'vertical' }} />
            </Field>
          </div>
        ) : (
          // ── CONFIRM — DIFF prehľad (ústava 53.8) ──
          <div>
            {isNew ? (
              <p style={{ fontSize: TYPO.sizes.base, color: COLORS.text }}>
                Pribudne kontakt <strong>{ed.values.meno}</strong> pri partnerovi <strong>{partnerMeno}</strong>.
              </p>
            ) : ed.diff.length === 0 ? (
              <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead>
                  <tr style={{ background: TINT.nav }}>
                    <th style={thStyle}>Pole</th><th style={thStyle}>Pôvodné</th><th style={thStyle}>Nové</th>
                  </tr>
                </thead>
                <tbody>
                  {ed.diff.map(d => (
                    <tr key={d.name}>
                      <td style={tdStyle}>{d.label}</td>
                      <td style={{ ...tdStyle, color: COLORS.muted, textDecoration: 'line-through' }}>{d.from}</td>
                      <td style={{ ...tdStyle, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>{d.to}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Modal>

      {/* DIRTY dialóg — Uložiť / Pokračovať / Zahodiť (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </>
  )
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'block' }}>
      <div style={{
        fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted,
        marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.04em',
      }}>{label}</div>
      {children}
    </label>
  )
}

const inputStyle = {
  width: '100%', padding: '6px 10px', fontSize: TYPO.sizes.base, fontFamily: 'inherit',
  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, outline: 'none', boxSizing: 'border-box',
}
const thStyle = {
  textAlign: 'left', padding: '6px 10px', fontSize: TYPO.sizes.xs, color: COLORS.nav,
  textTransform: 'uppercase', letterSpacing: '0.04em', borderBottom: `1px solid ${COLORS.line}`,
}
const tdStyle = { padding: '6px 10px', borderBottom: `1px solid ${COLORS.lineSoft}` }

// ╔══════════════════════════════════════════════════════════════════╗
// ║  DoD (ústava 9.D.1 bod 3) — p93                                  ║
// ║  [x] CFG vyplnené · [x] EDIT_FIELDS · [x] zámok (useRecordEditor) ║
// ║  [x] DIRTY dialóg · [x] Form → Confirm + DIFF · [x] HistoryPanel   ║
// ║  [x] hľadanie bez diakritiky aj podľa čísla · [x] SearchableSelect ║
// ║  [x] bez výplní mimo TINT · [x] dedup (duplicate z POST)          ║
// ║  [x] Alt+N a / · [x] starý modul: kontakty pri partnerovi ostávajú ║
// ╚══════════════════════════════════════════════════════════════════╝
